import { render, staticRenderFns } from "./ViewWrapper.vue?vue&type=template&id=475f78bb&"
import script from "./ViewWrapper.vue?vue&type=script&lang=js&"
export * from "./ViewWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ViewWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports